<template>
  <div>
    <a-modal
      :visible="visible"
      title="新增库存"
      :confirmLoading="confirmLoading"
      @ok="confirm"
      @cancel="cancel"
      closable
      class="createDistributionStock"
    >
      <ak-inputs v-model="stockData" :options="options" ref="input" />
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String, // 假如当前model显示为category格式，则会将当前的值传入
    store: String,
    agent: String
  },
  data () {
    return {
      visible: true,
      confirmLoading: false,
      stockData: {
        product: null,
        num: null
      },
      options: [],
      storeData: this.store,
      agentData: this.agent
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      if (this.record) {
        this.storeData = this.record.objectId
        this.agentData = this.record.agent.objectId
      }
      console.log(this.record)
      this.options.push(
        {
          name: 'product',
          note: '商品',
          type: 'Pointer',
          targetClass: 'winWinMerchantProduct',
          searchKey: ['name'],
          validators: [
            (val) => val ? null : '不可为空'
          ],
          listWhere: (where) => {
            where.winWinMerchant = this.agentData
            where.isDelete = false
          }
        },
        {
          name: 'num',
          note: '铺货库存',
          type: 'Number',
          validators: [
            (val) => val ? null : '不可为空',
            (value) => value < 0 ? '铺货库存不可为负数' : null,
            (value) => {
              let reg = /^\d+$/
              return reg.test(value) ? null : '铺货库存必须为正整数'
            }

          ]
        }
      )
    },
    cancel () {
      this.$emit('complete', 'cancel')
    },
    async confirm () {
      try {
        this.confirmLoading = true
        let erros = await this.$refs.input.validate()
        if (Object.keys(erros).length) {
          this.confirmLoading = false
          return this.$notification['warning']({
            message: '警告',
            description: '请填写完整信息'
          })
        }
        let { data: res } = await this.$tkParse.get(`/classes/distributionStock`, {
          params: {
            where: {
              winWinMerchantProduct: this.stockData.product,
              store: this.storeData,
              isDelete: false
            }
          }
        })
        if (res.results.length) {
          this.confirmLoading = false
          return this.$notification['warning']({
            message: '警告',
            description: '该商品已存在,不可重复添加'
          })
        }
        let { data: store } = await this.$tkParse.get(`/classes/store/${this.storeData}`)
        let { data: winWinMerchantProduct } = await this.$tkParse.get(`/classes/winWinMerchantProduct/${this.stockData.product}`, {
          params: {
            include: 'commodity'
          }
        })
        let { data: stock } = await this.$tkParse.post(`/classes/distributionStock`, {
          winWinMerchantProduct: this.stockData.product,
          store: this.storeData,
          afterChange: this.stockData.num,
          status: 'unconfirmed',
          isDelete: false,
          isDisabled: false,
          agent: store.agent,
          warZone: store.warZone,
          regional: store.regional,
          salesman: store.salesman,
          series: winWinMerchantProduct.commodity.series,
          voltage: winWinMerchantProduct.commodity.voltage,
          capacity: winWinMerchantProduct.commodity.capacity,
          agency: store.agency,
          salesmancy: store.salesmancy
        })
        await this.$tkParse.post(`/classes/notification`, {
          head: '铺货库存变动',
          type: 'system',
          user: store.user,
          content: '发现铺货库存有变动，请尽快确认。',
          isGroup: false,
          publicBy: this.$store.state.user.objectId,
          className: 'distributionStock',
          readUsers: [],
          resourceId: stock.objectId,
          associationType: 'distributionStock'
        })
        this.confirmLoading = false
        this.visible = false
        this.$emit('complete', 'cancel')
        this.$emit('refresh')
        this.$notification['success']({
          message: '操作成功',
          description: '保存成功'
        })
      } catch (e) {
        console.log(e)
        this.confirmLoading = false
        this.$notification['error']({
          message: '错误',
          description: '添加失败'
        })
      }
    }
  }
}
</script>
